module.exports = __webpack_public_path__ + "static/media/1client.25eea82e.png";